import React from 'react';

import { Money, formatMoney } from '@betterment/core';

import { TaxImpactGainsAllowance } from './TaxImpactGainsAllowance';
import { TaxImpactGainsAllowanceAnnualGainsAllowance } from './TaxImpactGainsAllowanceAnnualGainsAllowance';
import { TaxImpactGainsAllowanceRealizedGains } from './TaxImpactGainsAllowanceRealizedGains';
import { TaxImpactGainsAllowanceRemaining } from './TaxImpactGainsAllowanceRemaining';

import { ExpandableDetailContent } from '../expandable-detail/ExpandableDetailContent';
import { ExpandableDetailTrigger } from '../expandable-detail/ExpandableDetailTrigger';

export interface TaxImpactGainsAllowanceLoadedProps {
  remainingGainsAllowance: Money;
  gainsDetails: {
    annualGainsAllowance: Money;
    realizedGains: Money;
  };
}

export const TaxImpactGainsAllowanceLoaded: React.FC<TaxImpactGainsAllowanceLoadedProps> = ({
  remainingGainsAllowance,
  gainsDetails,
}) => {
  const remainingAllowance = formatMoney(remainingGainsAllowance);
  const annualGainsAllowance = formatMoney(gainsDetails.annualGainsAllowance);
  const realizedGains = formatMoney(gainsDetails.realizedGains);
  const shouldShowGainsAllowanceWarning = remainingGainsAllowance.cents < 0;

  return (
    <TaxImpactGainsAllowance>
      <TaxImpactGainsAllowanceRemaining showGainsAllowanceWarning={shouldShowGainsAllowanceWarning}>
        {remainingAllowance}
        <ExpandableDetailTrigger css={{ mr: 'space.0', ml: 'auto' }} openText="Hide details" closedText="See details" />
      </TaxImpactGainsAllowanceRemaining>
      <ExpandableDetailContent>
        <TaxImpactGainsAllowanceAnnualGainsAllowance>
          {annualGainsAllowance}
        </TaxImpactGainsAllowanceAnnualGainsAllowance>
        <TaxImpactGainsAllowanceRealizedGains>{realizedGains}</TaxImpactGainsAllowanceRealizedGains>
      </ExpandableDetailContent>
    </TaxImpactGainsAllowance>
  );
};
